// Environment Configuration
// This file manages all environment variables for the application

// Default values
const defaults = {
  API_BASE_URL: 'https://api.memu.pro',
  CDN_BASE_URL: 'https://d192tm8h0ep0ud.cloudfront.net/memu.pro',
  VERSION: '0.1.0',
  ENVIRONMENT: 'development',
  LOCAL_MODE: false,
  ENABLE_DEBUG: true,
  ENABLE_ANALYTICS: false,
  ENABLE_TOP_BANNER: true
};

// Safe boolean parser
const parseBooleanEnv = (value) => {
  if (value === 'true') return true;
  if (value === 'false') return false;
  return undefined;
};

// Environment variables configuration
export const ENV = {
  // API Configuration
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || defaults.API_BASE_URL,
  
  // CDN Configuration
  CDN_BASE_URL: process.env.REACT_APP_CDN_BASE_URL || defaults.CDN_BASE_URL,
  
  // Application Configuration
  VERSION: process.env.REACT_APP_VERSION || defaults.VERSION,
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || defaults.ENVIRONMENT,
  
  // Development Configuration
  LOCAL_MODE: process.env.REACT_APP_LOCAL_MODE === 'true' || defaults.LOCAL_MODE,
  ENABLE_DEBUG: process.env.REACT_APP_ENABLE_DEBUG === 'true' || defaults.ENABLE_DEBUG,
  ENABLE_ANALYTICS: process.env.REACT_APP_ENABLE_ANALYTICS === 'true' || defaults.ENABLE_ANALYTICS,

  // OpenObserve Configuration
  OO_ENABLED: process.env.REACT_APP_OO_ENABLED === 'true',
  OO_URL: process.env.REACT_APP_OO_URL || '',
  OO_ORG: process.env.REACT_APP_OO_ORG || '',
  OO_STREAM: process.env.REACT_APP_OO_STREAM || 'frontend_logs',
  OO_AUTH_TYPE: process.env.REACT_APP_OO_AUTH_TYPE || '', // token | basic | basic_b64
  OO_TOKEN: process.env.REACT_APP_OO_TOKEN || '',
  OO_USER: process.env.REACT_APP_OO_USER || '',
  OO_PASSWORD: process.env.REACT_APP_OO_PASSWORD || '',
  OO_BASIC_B64: process.env.REACT_APP_OO_BASIC_B64 || '',
  OO_BATCH_SIZE: Number(process.env.REACT_APP_OO_BATCH_SIZE || 20),
  OO_FLUSH_MS: Number(process.env.REACT_APP_OO_FLUSH_MS || 3000),

  // Feature Toggles
  ENABLE_TOP_BANNER: (() => {
    const v = parseBooleanEnv(process.env.REACT_APP_ENABLE_TOP_BANNER);
    return v !== undefined ? v : defaults.ENABLE_TOP_BANNER;
  })(),
  
  // Derived values
  get PIC_BASE_URL() {
    return LOCAL_MODE ? '' : this.CDN_BASE_URL;
  }
};

// Export individual values for convenience
export const {
  API_BASE_URL,
  CDN_BASE_URL,
  VERSION,
  ENVIRONMENT,
  LOCAL_MODE,
  ENABLE_DEBUG,
  ENABLE_ANALYTICS,
  ENABLE_TOP_BANNER
} = ENV;

export default ENV;
